(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('GtpController', GtpController);

    GtpController.$inject = ['$scope', '$rootScope', '$translate', '$stateParams', '$sce', '$timeout', 'GtpService', 'RequestService', 'Authenticate'];

    function GtpController($scope, $rootScope, $translate, $stateParams, $sce, $timeout, GtpService, RequestService, Authenticate) {
        var vm = this;

        if (!Authenticate.hasPermission('gtpList')) {
            return;
        }

        // Variables
        vm.gtpList = [];
        var searchParams = null;

        var hasError = false;
        vm.requestRunning = false;

        vm.view = {};
        vm.view.tooltip = '';

        // Methods Api
        vm.addGtp = addGtp;
        vm.editGtp = editGtp;
        vm.deleteGtp = deleteGtp;

        // Methods handlers
        vm.toggle = toggle;
        vm.isListEmpty = isListEmpty;
        vm.hasErrorList = hasErrorList;

        // Validation rules
        var rules = GtpService.getRules();

        // Methods Api
        function addGtp() {
            GtpService.addGtpModalConstructor($scope);
        }

        function editGtp(gtpItem) {
            if (gtpItem.gtpId > rules[gtpItem.oltModel].gtpId.max) {
                GtpService.errorModalConstructor({status: 'reserved', config: {}}, 'edit');
            } else {
                GtpService.editGtpModalConstructor(gtpItem.id, $scope);
            }
        }

        function deleteGtp(gtpItem) {
            if (gtpItem.gtpId > rules[gtpItem.oltModel].gtpId.max) {
                GtpService.errorModalConstructor({status: 'reserved', config: {}}, 'delete');
            } else {
                var dataAction = {
                    action: 'delete',
                    methodService: 'deleteGtp',
                    methodExtra: function (gtpItem) {
                        vm.gtpList.forEach(function (item, index, array) {
                            if (item.id === gtpItem[0].id) {
                                array.splice(index, 1);
                            }
                        });
                    }
                };
                GtpService.confirmationModalConstructor([gtpItem], dataAction);
            }
        }

        function getTooltip() {
            translateTooltip()
            var translateChangeListener = $rootScope.$on('$translateChangeSuccess', translateTooltip);
            $rootScope.$on('$destroy', translateChangeListener);
        }

        function translateTooltip() {
            $translate('tooltip.addGtp').then(function (translation) {
                vm.view.tooltip = $sce.trustAsHtml(translation);
            });
        }

        function getGtpList() {
            RequestService.cancelRequests(['gtps']);
            vm.gtpList = [];
            vm.requestRunning = true;
            GtpService.listGtp(searchParams, true).then(successListGtp).catch(errorListGtp);
        }

        // Methods handle
        function toggle(id) {
            vm.gtpList.forEach(function (item) {
                if (item.id == id) {
                    item.opened = !item.opened;
                } else {
                    item.opened = false;
                }
            });
        }

        function isListEmpty() {
            return !vm.requestRunning && !vm.gtpList.length && !hasError;
        }

        function hasErrorList() {
            return !vm.requestRunning && !vm.gtpList.length && hasError;
        }

        var listenerUpdate = $rootScope.$on('gtpUpdateSuccess', function (event, data) {
            vm.gtpList.forEach(function (gtp, index, arrayList) {
                if (gtp.id == data.id) {
                    arrayList[index] = angular.copy(data);
                    arrayList[index].opened = true;
                }
            });
        })
        $rootScope.$on('$destroy', listenerUpdate);

        var listenerAdd = $rootScope.$on('gtpAddSuccess', function (event, data) {
            var gtpItem = angular.copy(data);
            vm.gtpList.push(gtpItem);
        })
        $rootScope.$on('$destroy', listenerAdd);

        // Request Callbacks
        function successListGtp(data) {
            vm.requestRunning = false;
            vm.gtpList = data;
            hasError = false;
        }

        function errorListGtp(response) {
            vm.requestRunning = false;
            GtpService.errorModalConstructor(response, 'list');
            hasError = true;
        }

        function initialize() {
            if (!$stateParams.id) {
                getGtpList();
            }
            getTooltip();
        }

        $scope.$on('eventFilter', function (event, data) {
            searchParams = data;
            getGtpList();
        });

        $scope.$on('$viewContentLoaded', function () {
            vm.requestRunning = true;
            $timeout(initialize);
        });

    }
})();
